import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Star } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ROIAndTestimonials() {
  return <section className="py-24 bg-ink-900 text-cream-50 relative overflow-hidden" data-id="element-245">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-246"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-247">
        {/* Numbers Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="mb-24" data-id="element-248">
          <div className="text-center mb-12" data-id="element-249">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-gold-400 mb-4" data-id="element-250">
              LOS NÚMEROS QUE LO DICEN TODO
            </h2>
            <p className="text-xl text-cream-50/80" data-id="element-251">
              Matemáticas simples. Ganancias reales.
            </p>
          </div>

          <div className="overflow-x-auto bg-white/5 rounded-2xl backdrop-blur-sm border border-white/10 mb-12" data-id="element-252">
            <table className="w-full text-left border-collapse" data-id="element-253">
              <thead data-id="element-254">
                <tr className="border-b border-white/10 text-gold-400 text-sm uppercase tracking-wider" data-id="element-255">
                  <th className="p-6 font-bold" data-id="element-256">Kit</th>
                  <th className="p-6 font-bold" data-id="element-257">Inversión</th>
                  <th className="p-6 font-bold" data-id="element-258">Precio Venta</th>
                  <th className="p-6 font-bold" data-id="element-259">Ganancia</th>
                  <th className="p-6 font-bold" data-id="element-260">ROI</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5" data-id="element-261">
                <tr className="hover:bg-white/5 transition-colors" data-id="element-262">
                  <td className="p-6 font-medium flex items-center" data-id="element-263">
                    <span className="mr-3 text-xl" data-id="element-264">🛁</span> Serenidad en Caja
                  </td>
                  <td className="p-6" data-id="element-265">$14.75</td>
                  <td className="p-6" data-id="element-266">$45-$55</td>
                  <td className="p-6 text-emerald-400 font-bold" data-id="element-267">$30-$40</td>
                  <td className="p-6 text-emerald-400" data-id="element-268">+203%</td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-269">
                  <td className="p-6 font-medium flex items-center" data-id="element-270">
                    <span className="mr-3 text-xl" data-id="element-271">🌹</span> Elixir Rosas &
                    Terciopelo
                  </td>
                  <td className="p-6" data-id="element-272">$19.50</td>
                  <td className="p-6" data-id="element-273">$55-$65</td>
                  <td className="p-6 text-emerald-400 font-bold" data-id="element-274">$35-$45</td>
                  <td className="p-6 text-emerald-400" data-id="element-275">+179%</td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-276">
                  <td className="p-6 font-medium flex items-center" data-id="element-277">
                    <span className="mr-3 text-xl" data-id="element-278">✨</span> Glow & Go
                  </td>
                  <td className="p-6" data-id="element-279">$12.75</td>
                  <td className="p-6" data-id="element-280">$40-$50</td>
                  <td className="p-6 text-emerald-400 font-bold" data-id="element-281">$27-$37</td>
                  <td className="p-6 text-emerald-400" data-id="element-282">+212%</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-283">
            <div className="bg-emerald-900/40 border border-emerald-800/50 p-8 rounded-2xl" data-id="element-284">
              <h4 className="text-xl font-bold text-white mb-6 flex items-center" data-id="element-285">
                <TrendingUp className="w-6 h-6 mr-3 text-gold-400" data-id="element-286" />
                Si vendes 10 kits esta semana:
              </h4>
              <ul className="space-y-3 text-lg" data-id="element-287">
                <li className="flex justify-between border-b border-white/10 pb-2" data-id="element-288">
                  <span className="text-cream-50/70" data-id="element-289">Ingresos brutos:</span>{' '}
                  <span data-id="element-290">~$500</span>
                </li>
                <li className="flex justify-between border-b border-white/10 pb-2" data-id="element-291">
                  <span className="text-cream-50/70" data-id="element-292">Costo de mercancía:</span>{' '}
                  <span data-id="element-293">~$155</span>
                </li>
                <li className="flex justify-between pt-2 font-bold text-gold-400 text-xl" data-id="element-294">
                  <span data-id="element-295">Ganancia neta:</span> <span data-id="element-296">~$345 en una semana</span>
                </li>
              </ul>
            </div>

            <div className="bg-emerald-900/60 border border-emerald-500/30 p-8 rounded-2xl relative overflow-hidden" data-id="element-297">
              <div className="absolute top-0 right-0 bg-gold-500 text-ink-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-298">
                PROYECCIÓN MAYO
              </div>
              <h4 className="text-xl font-bold text-white mb-6 flex items-center" data-id="element-299">
                <TrendingUp className="w-6 h-6 mr-3 text-gold-400" data-id="element-300" />
                Si vendes 25 kits en todo Mayo:
              </h4>
              <ul className="space-y-3 text-lg" data-id="element-301">
                <li className="flex justify-between border-b border-white/10 pb-2" data-id="element-302">
                  <span className="text-cream-50/70" data-id="element-303">Ingresos brutos:</span>{' '}
                  <span data-id="element-304">~$1,250</span>
                </li>
                <li className="flex justify-between border-b border-white/10 pb-2" data-id="element-305">
                  <span className="text-cream-50/70" data-id="element-306">Costo de mercancía:</span>{' '}
                  <span data-id="element-307">~$388</span>
                </li>
                <li className="flex justify-between pt-2 font-bold text-gold-400 text-2xl" data-id="element-308">
                  <span data-id="element-309">Ganancia neta:</span> <span data-id="element-310">~$862 en un mes</span>
                </li>
              </ul>
            </div>
          </div>

          <p className="text-center text-2xl font-serif italic mt-12 text-cream-50" data-id="element-311">
            ¿Cuánto tiempo llevas buscando una forma de ganar $862 extra al mes?
          </p>
        </motion.div>

        {/* Testimonials */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.1
          }
        }
      }} data-id="element-312">
          <div className="text-center mb-16" data-id="element-313">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-314">
              LO QUE DICEN QUIENES YA LO PROBARON
            </h2>
            <div className="w-16 h-1 bg-gold-400 mx-auto" data-id="element-315"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-316">
            {[{
            quote: 'Honestamente pensé que era otro ebook genérico. Armé mi primer kit el miércoles por la noche. El jueves lo publiqué en mis stories. El viernes tenía 4 pedidos. El domingo ya había ganado $160. Nunca había vendido nada en mi vida.',
            author: 'Gabriela R.',
            desc: 'mamá de 3, Texas'
          }, {
            quote: 'El paso a paso del listón doble me pareció imposible cuando lo leí. Lo hice en mi primer intento. Mis clientas me preguntan dónde compro los materiales pensando que son caros. Nunca les digo que el listón costó $1.50 en Hobby Lobby.',
            author: 'Daniela M.',
            desc: 'estudiante universitaria, Florida'
          }, {
            quote: 'Llevo 3 años intentando emprender. Este es el primer método que me dio resultados en menos de una semana. La guía de fotografía sola ya valió lo que pagué.',
            author: 'Carmen L.',
            desc: 'empleada administrativa, California'
          }, {
            quote: 'Vendí el primer kit antes de terminarlo de armar. Mi vecina lo vio en mi mesa mientras lo hacía y me lo compró en ese momento. $45 mientras lo estaba creando.',
            author: 'Paola V.',
            desc: 'ama de casa, Nueva York'
          }].map((testimonial, i) => <motion.div key={i} variants={fadeInUp} className="bg-white text-ink-900 p-8 rounded-2xl relative" data-id="element-317">
                <div className="text-gold-400 flex mb-4" data-id="element-318">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-319" />)}
                </div>
                <p className="text-lg italic mb-6 leading-relaxed" data-id="element-320">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-321">
                  <p className="font-bold text-emerald-900" data-id="element-322">
                    {testimonial.author}
                  </p>
                  <p className="text-ink-800/70 text-sm" data-id="element-323">{testimonial.desc}</p>
                </div>
                <div className="absolute top-6 right-6 text-blush-100 opacity-30" data-id="element-324">
                  <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24" data-id="element-325">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-326" />
                  </svg>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}